import React from 'react';
import { motion } from 'framer-motion';
import { Award, GraduationCap, Heart, MapPin } from 'lucide-react';
const credentials = [{
  icon: GraduationCap,
  label: 'Education',
  value: 'University of Nebraska–Lincoln, Undergraduate & Dental School'
}, {
  icon: Award,
  label: 'AGD Master',
  value: 'Fellow & Master of the Academy of General Dentistry'
}, {
  icon: MapPin,
  label: 'Memberships',
  value: 'ADA, Nebraska Dental Assoc., Lincoln Dental Assoc., Academy of Sports Dentistry'
}, {
  icon: Heart,
  label: 'Recognition',
  value: "Listed in the 2020 Who's Who in America"
}];
export function Team() {
  return <section id="team" className="py-24 bg-white" data-id="element-179">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-180">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-181">
          <h2 className="text-sage font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-182">
            About the Doctor
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal-800 mb-6" data-id="element-183">
            Meet Dr. Dennis Martin.
          </h3>
          <p className="text-lg text-charcoal-500" data-id="element-184">
            A Nebraska-trained dentist with a passion for continuing education,
            community, and a good half marathon.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-185">
          {/* Portrait */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5 relative" data-id="element-186">
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-soft" data-id="element-187">
              <img src="https://nebraskaagd.org/wp-content/uploads/2023/01/Dr-Dennis-Martin.jpg" alt="Dr. Dennis Martin, DDS" className="w-full h-full object-cover" data-id="element-188" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[radial-gradient(#009FE3_2px,transparent_2px)] [background-size:12px_12px] opacity-20 -z-10" data-id="element-189"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-sage-100 rounded-full blur-3xl -z-10" data-id="element-190"></div>
          </motion.div>

          {/* Bio + credentials */}
          <div className="lg:col-span-7 space-y-10" data-id="element-191">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="space-y-5 text-charcoal-600 leading-relaxed text-lg" data-id="element-192">
              <p data-id="element-193">
                Dr. Martin grew up in Rose Creek, Minnesota; Mitchell, Iowa; and
                Joplin, Missouri. He attended both undergraduate and dental
                school at the University of Nebraska–Lincoln.
              </p>
              <p data-id="element-194">
                After completing dental school, Dr. Martin trained with dentists
                from The POS group, where he received extensive training in
                orthodontics and orthopedic appliances. He then purchased a
                practice from James Dixon in Clinton, Iowa, practicing there
                until 2003 before opening his offices in Lincoln and Waverly.
              </p>
              <p data-id="element-195">
                Continuing education keeps his passion for dentistry alive — and
                it directly benefits his patients. Outside the office, Dr.
                Martin took up running in 2011, finishing the full Lincoln
                Marathon in 2015 along with 21 half marathons by 2018. He's also
                learning to dance, plays volleyball, and rides his bike around
                town.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-cream rounded-3xl p-8 border border-sage-100" data-id="element-196">
              <h4 className="font-serif text-2xl text-charcoal-800 mb-6" data-id="element-197">
                Credentials & Affiliations
              </h4>
              <ul className="grid sm:grid-cols-2 gap-6" data-id="element-198">
                {credentials.map((c, i) => <li key={i} className="flex gap-4" data-id="element-199">
                    <div className="w-10 h-10 rounded-xl bg-white shadow-sm flex items-center justify-center text-sage shrink-0" data-id="element-200">
                      <c.icon size={20} strokeWidth={2} data-id="element-201" />
                    </div>
                    <div data-id="element-202">
                      <p className="text-xs font-semibold tracking-wider uppercase text-sage-600 mb-1" data-id="element-203">
                        {c.label}
                      </p>
                      <p className="text-charcoal-700 leading-snug text-sm" data-id="element-204">
                        {c.value}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}